import { Meta, Title } from "@solidjs/meta";
import { useSearchParams } from "@solidjs/router";
import type { Component } from "solid-js";
import { useI18n } from "@/api/i18n";
import { Container, ContainerHeader } from "@/components/shared/Container";
import { useGetUserApplications } from "@/domains/application/api";
import { RootLayout } from "@/domains/auth/routes/layout";
import { JobList } from "@/domains/job-offer/components/jobs";
import { SearchBar } from "@/domains/job-offer/components/SearchBar";
import {
  FilterProvider,
  type FilterStore,
  standardizeFilterStore,
} from "@/domains/job-offer/context/FilterProvider";
import { JobListProvider } from "@/domains/job-offer/context/JobListContext";

const HomeRoute: Component = () => {
  const { t } = useI18n();
  const [searchParams] = useSearchParams();
  const initialState = {
    daily_rate_min: searchParams.daily_rate_min ?? null,
    daily_rate_max: searchParams.daily_rate_max ?? null,
    skills: searchParams.skills ?? null,
    employment_type: searchParams.employment_type ?? null,
    job_category: searchParams.job_category ?? null,
    budget: searchParams.budget ?? null,
    duration: searchParams.duration ?? null,
    effort: searchParams.effort ?? null,
    payment_type: searchParams.payment_type ?? null,
    experience_level: searchParams.experience_level ?? null,
    sortBy: searchParams.sortBy ?? "created_at",
    sortOrder: searchParams.sortOrder ?? "desc",
    search: searchParams.search ?? null,
    remote_policy: searchParams.remote_policy ?? null,
    start_date: searchParams.start_date ?? null,
    renewable:
      searchParams.renewable === "true"
        ? true
        : searchParams.renewable === "false"
          ? false
          : null,
  } as Partial<Exclude<FilterStore, "availableFilters">>;
  const parsedInitialState = standardizeFilterStore(initialState);
  const userApplications = useGetUserApplications();
  return (
    <RootLayout>
      <Title>SeVedemo</Title>
      <Meta
        name="description"
        content="Trova freelance e cerca opportunità di lavoro solo per freelance"
      />
      <div class="w-full">
        <FilterProvider initialState={parsedInitialState}>
          <ContainerHeader class="bg-linear-to-r from-matisse-900 via-matisse-800 to-indigo-900 pb-8">
            <Container size="6xl">
              <div class="flex flex-col gap-6">
                <h1 class="text-4xl font-bold text-tertiary-foreground">
                  {t("home.header.title")}{" "}
                  <span class="text-notification">
                    ({t("home.header.subtitle")})
                  </span>
                </h1>
                <SearchBar />
              </div>
            </Container>
          </ContainerHeader>
          <Container size="6xl" class="mt-4">
            <JobListProvider>
              <JobList
                userApplications={userApplications.data?.job_application ?? []}
              />
            </JobListProvider>
          </Container>
        </FilterProvider>
      </div>
    </RootLayout>
  );
};

export default HomeRoute;
